/**
 * Product Lookup view — one-click external searches.
 *
 * Each button opens a new tab pointing at TCGplayer, eBay sold listings, or
 * PriceCharting pre-filled with the typed query. The page itself doesn't
 * embed those sites (X-Frame-Options blocks that anyway).
 */
import { escapeHtml, toast } from "../lib/dom";

const ProductLookup: { query: string } = { query: "" };

const PRODUCT_SITES: Record<string, { label: string; url: (q: string) => string }> = {
  tcgplayer:     { label: "TCGplayer",          url: q => "https://www.tcgplayer.com/search/all/product?q=" + encodeURIComponent(q) + "&view=grid" },
  ebay:          { label: "eBay sold listings", url: q => "https://www.ebay.com/sch/i.html?_nkw=" + encodeURIComponent(q) + "&LH_Sold=1&LH_Complete=1" },
  pricecharting: { label: "PriceCharting",      url: q => "https://www.pricecharting.com/search-products?q=" + encodeURIComponent(q) },
};

export function viewLookup(root: HTMLElement): void {
  const pl = ProductLookup;
  root.innerHTML = `
    <div class="panel p-4">
      <h3 class="font-semibold mb-2">Product Lookup</h3>
      <p class="text-sm text-[var(--muted)] mb-1">One-click searches save typing.</p>
      <p class="text-xs text-[var(--muted)] mb-3">Example: <code class="px-1.5 py-0.5 rounded bg-[var(--panel-2)]">Surging Sparks Booster Box</code></p>
      <div class="flex flex-wrap gap-2">
        <input id="productLookupInput" class="input flex-1 min-w-[220px]"
               data-focus-key="product-lookup-search"
               placeholder="Type a product or card name…"
               value="${escapeHtml(pl.query)}"
               onkeydown="if(event.key==='Enter'){event.preventDefault();searchProduct('tcgplayer');}">
        <button class="btn btn-ghost" onclick="searchProduct('tcgplayer')">TCGplayer</button>
        <button class="btn btn-ghost" onclick="searchProduct('ebay')">eBay sold</button>
        <button class="btn btn-ghost" onclick="searchProduct('pricecharting')">PriceCharting</button>
      </div>
      <div class="text-xs text-[var(--muted)] mt-3">Each search opens in a new browser tab.</div>
    </div>
  `;
}

export function searchProduct(site: string): void {
  const inp = document.getElementById("productLookupInput") as HTMLInputElement | null;
  const q = (inp?.value || "").trim();
  if (!q) { toast("Type something to search first.", "err"); return; }
  const cfg = PRODUCT_SITES[site];
  if (!cfg) return;
  ProductLookup.query = q;
  window.open(cfg.url(q), "_blank", "noopener");
}

// Inline-handler bridge for the buttons.
(window as any).searchProduct = searchProduct;
